// extracted by mini-css-extract-plugin
export default {"cls1":"Menu-cls1_YiZ","cls2":"Menu-cls2_PS7 Menu-cls1_YiZ"};